import React from "react";
import PropTypes from "prop-types";
import ReqLink from "components/RequestsLink";
import NoTableData from "components/NoTableData";
import { getRequestTypeTitle } from "helpers/RequestHelper";

const LabResultRowOta = ({ tableRows }) => {
  if (tableRows.length) {
    return tableRows.map(row => {
      const {
        id,
        name,
        modelnumber,
        requesttypeid,
        formatedtransactionnumber
      } = row;

      const tn = formatedtransactionnumber;

      return (
        <tr key={id}>
          <td>
            <ReqLink linkTitle={tn} requestId={id} category="results" />
          </td>
          <td>{name}</td>
          <td>{modelnumber}</td>
          <td>{getRequestTypeTitle(requesttypeid)}</td>
        </tr>
      );
    });
  }

  return <NoTableData colSpan={4} />;
};

LabResultRowOta.propTypes = {
  tableRows: PropTypes.array.isRequired
};

export default LabResultRowOta;
